import mock07 from '../assets/images/qgis_plugin.png';
import mock08 from '../assets/images/ismr_downloader.png';
import mock09 from '../assets/images/chatbot_unesp.png';
import mock10 from '../assets/images/ismr_home.png';
import '../assets/styles/Project.scss';
import { useTranslation } from 'react-i18next';

function Project() {
    const { t } = useTranslation();

    return(
    <div className="projects-container" id="projects">
        <h1>{t("projects")}</h1>
        <div className="projects-grid">
            <div className="project">
                <a href="https://ismrquerytool.fct.unesp.br/" target="_blank" rel="noreferrer"><img src={mock10} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://ismrquerytool.fct.unesp.br/" target="_blank" rel="noreferrer"><h2>ISMR Query Tool</h2></a>
                <p
                    dangerouslySetInnerHTML={{
                    __html: (t("projects_text.ismr_desc") as string) || "",
                    }}
                />
            </div>
            <div className="project">
                <a href="https://github.com/yingyangtongxue/ismr_downloader" target="_blank" rel="noreferrer"><img src={mock08} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://github.com/yingyangtongxue/ismr_downloader" target="_blank" rel="noreferrer"><h2>ISMR Downloader</h2></a>
                <p
                    dangerouslySetInnerHTML={{
                        __html: (t("projects_text.ismr_downloader_desc") as string) || "",
                    }}
                />
            </div>
            <div className="project">
                <a href="https://github.com/yingyangtongxue/legislation-chatbot" target="_blank" rel="noreferrer"><img src={mock09} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://github.com/yingyangtongxue/legislation-chatbot" target="_blank" rel="noreferrer"><h2>UNESP Legislation Chatbot</h2></a>
                <p
                    dangerouslySetInnerHTML={{
                        __html: (t("projects_text.chatbot_unesp_desc") as string) || "",
                    }}
                />
            </div>
            <div className="project">
                <a href="" target="_blank" rel="noreferrer"><img src={mock07} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="" target="_blank" rel="noreferrer"><h2>GEE Time Series</h2></a>
                <p
                    dangerouslySetInnerHTML={{
                        __html: (t("projects_text.qgis_plugin_desc") as string) || "",
                    }}
                />
            </div>
        </div>
    </div>
    );
}

export default Project;